import React, { useEffect } from "react";
import MsgBox from "./index";

const MsgBoxContainer = (props) => {
  useEffect(() => {
    if (props.componentIsReady) {
      props.componentIsReady(props.id);
    }
  }, []);

  return <MsgBox.ToastContainer />;
};

export default MsgBoxContainer;
